<template>

    <div>

        <div class="flex justify-between items-start gap-x-8 text-sm">

            <div class="flex flex-col items-start ">
                <div class="font-medium text-sm flex items-center gap-x-2">
                    Hide sensitive data
                    <UpgradePlan v-if="!canChangeFeature" />
                </div>
                <a :href="route('settings.index') + '#snippet'" title="Birdie snippet"
                    class="text-sm italic text-birdie-blue hover:underline">Birdie snippet is required</a>
                <div class="flex flex-grow text-sm mt-3">
                    Automatically blur sensitive data within your webapp - &nbsp;<docs-link
                        href="https://docs.birdie.so/birdie-docs/security/hide-sensitive-data" />
                </div>
            </div>

            <div class="flex items-center flex-shrink">
                <toggle :checked="blur_enabled && canChangeFeature" :disabled="!canChangeFeature" @click.prevent.stop
                    @update="toggleEnabled"></toggle>
            </div>

        </div>

        <div class="flex mt-5 text-sm">
            <div class="flex flex-grow items-center gap-x-1">



                <!-- <div class="flex font-bold flex-1">Apply the feature to these selectors:</div>
                <div class="flex flex-1 justify-end">
                    <input type="text" ref="team_name_field" v-model="form.name"
                        @input="changedTeamName"
                        class="text-left w-full inline py-2 mt-0 px-3 border-0 border-gray-200 focus:ring-0 focus:border-blue-500 font-bold bg-gray-100 focus:bg-blue-50 text-birdie-blue focus:text-blue-600 rounded-lg" />
                </div> -->


                <div class="flex">
                    Apply the feature to these selectors:
                </div>
                <div class="flex flex-1 justify-end">
                    <input type="text" :disabled="!canChangeFeature" :value="blur_elements_form"
                        @input="changedInput($event)" placeholder=".private-info"
                        class="text-left w-full inline py-2 mt-0 px-3 border-0 border-gray-200 focus:ring-0 focus:border-blue-500 bg-gray-100 focus:bg-blue-50 text-birdie-blue focus:text-blue-600 rounded-lg text-sm"
                        :class="{ 'opacity-50': !canChangeFeature }" />
                </div>


            </div>
        </div>






    </div>



</template>






<script>

import Toggle from '@/Components/UI/Toggle'
import UpgradePlan from '@/Components/UI/UpgradePlan'

// import hljs from 'highlight.js/lib/common'
// import hljsVuePlugin from "@highlightjs/vue-plugin"
// import 'highlight.js/styles/github-dark.css'

export default {

    props: ["w_settings"],

    components: {
        Toggle, UpgradePlan
        //highlightjs: hljsVuePlugin.component,
    },

    data() {
        return {
            canChangeFeature: this.$page.props.isz || this.$page.props.plan_blur,
            widget_settings: this.w_settings,
            //blur_enabled: false,
            //blur_elements: [],
            blur_elements_form: "",
            timeout: Object,
            buffer: 1000,
            demo_toggle: true
        }
    },

    created() {
        //console.log(this.widget_settings)
        if (this.widget_settings) {
            if (this.widget_settings.sensitive_data) {
                if (this.widget_settings.sensitive_data.elements.length > 0) {
                    //console.log(this.widget_settings.sensitive_data.elements)
                    this.blur_elements_form = this.widget_settings.sensitive_data.elements.join(", ")
                }
            } else {
                this.widget_settings.sensitive_data = {
                    enable_default: true,
                    forced: false,
                    enabled: false,
                    elements: []
                }
            }
        }
    },
    computed: {
        blur_enabled: function () {
            if (this.widget_settings.sensitive_data) {
                return this.widget_settings.sensitive_data.enabled == true
            }
            return false
        },
        bg_image() {
            return this.demo_toggle ? "/img/blursetting2.png" : "/img/blursetting1.png"
        }
        // blur_elements: function() {
        //     if (this.widget_settings) {
        //         if (this.widget_settings.elements) {
        //             if (this.widget_settings.elements.length > 0) {
        //                 return this.widget_settings.elements.join(", ")
        //             }
        //         }
        //     }
        //     return ""
        // }
        /*is_light() {
            //return ColorUtil.lightOrDark(this.widget_settings.color) == "light"
        },
        bg_image() {
            //return this.widget_settings.position == "blank" ? "/img/custom_launcher.png" : "/img/widget_browser.png"
        }*/
    },
    mounted() {

    },
    methods: {
        showUpgradeModal: function () {
            this.EventBus.emit('showUpgrade', ['feature', 'blur'])
        },
        toggleEnabled: function (checked) {
            //console.log("toggleEnabled",checked)
            this.widget_settings.sensitive_data.enabled = checked
            this.updateBlur()
        },
        copied: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Code snippet copied in your clipboard!", options)
            this.set_onboarding_done()

        },
        changedInput: function (event) {
            clearTimeout(this.timeout);
            const value = event.target.value.trim()
            // if (value == "") {
            //     if (way == "incoming") {
            //         this.autodelete_incoming_form = ""
            //     } else {
            //         this.autodelete_outgoing_form = ""
            //     }
            //     this.$forceUpdate()
            //     return
            // }

            const lastChar = value.substr(value.length - 1)
            //console.log(lastChar)
            if (!lastChar.match("[a-zA-Z0-9,@.\\]\\[\s*:_'\\-#]")) {
                this.blur_elements_form = value.substr(0, value.length - 1)
                this.$forceUpdate()
                return
            }

            //return test.matches("[a-zA-Z0-9,@. :_'\\s-#\[\]]*");

            //let pattern = /^\d+$/;
            // if (!pattern.test(value)) { // not a number, keep previous value
            //     if (way == "incoming") {
            //         this.autodelete_incoming_form = this.autodelete_incoming
            //     } else {
            //         this.autodelete_outgoing_form = this.autodelete_outgoing
            //     }
            //     this.$forceUpdate()
            //     return
            // }

            // let value_without_leading_zeros = value.replace(/^0+/, '')
            // if (value_without_leading_zeros == "") {
            //     if (way == "incoming") {
            //         this.autodelete_incoming_form = ""
            //     } else {
            //         this.autodelete_outgoing_form = ""
            //     }
            //     this.$forceUpdate()
            //     return
            // }

            this.blur_elements_form = value
            this.timeout = setTimeout(function () { this.updateBlur() }.bind(this), this.buffer);

            // if (value_without_leading_zeros.toString().length > this.maxValue.toString().length ||
            //     value_without_leading_zeros > (this.maxValue + 1)) {
            //     if (way == "incoming") {
            //         this.autodelete_incoming_form = this.autodelete_incoming
            //     } else {
            //         this.autodelete_outgoing_form = this.autodelete_outgoing
            //     }
            //     this.$forceUpdate()
            //     if (!this.shot_max_alert) {
            //         this.shot_max_alert = true
            //         let options = {
            //             type: "info",
            //             timeout: 5000,
            //             position: "top-right",
            //             hideProgressBar: false,
            //         }
            //         this.$moshaToast("Enter a value between 1 and "+this.maxValue+" days", options)
            //     }
            //     return
            // } else {
            //     if (way == "incoming") {
            //         this.autodelete_incoming = value_without_leading_zeros
            //         this.autodelete_incoming_form = value_without_leading_zeros
            //     } else {
            //         this.autodelete_outgoing = value_without_leading_zeros
            //         this.autodelete_outgoing_form = value_without_leading_zeros
            //     }
            //     this.timeout = setTimeout(function () { this.updateSecurity(way) }.bind(this), this.buffer);
            // }
        },

        updateBlur: function (type) {
            var url = this.$page.props.api_url + '/v1/settings/blur';
            var meta_name = "sensitive_data"
            var elements_to_blur = []
            const split = this.blur_elements_form.split(',')
            for (var s = 0; s < split.length; s++) {
                if (split[s].trim() != "") {
                    elements_to_blur.push(split[s].trim())
                }
            }
            var meta_value = {
                enable_default: true,
                forced: false,
                enabled: this.blur_enabled,
                elements: elements_to_blur
            }
            //console.log(meta_value)
            // if (Object.keys(meta_value).length === 0) {
            //     url = this.$page.props.api_url+'/v1/team/delete_meta';
            // }

            // var meta_name = "autodelete_incoming";
            // var meta_value = this.autodelete_incoming;
            // if (type == "outgoing") {
            //     meta_name = "autodelete_outgoing";
            //     meta_value = this.autodelete_outgoing;
            // }

            var params = {
                meta: meta_name,
                value: meta_value
            };

            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    this.widget_settings.sensitive_data = meta_value
                })
                .catch(e => {
                    //console.error(e);
                });
        },

        /*position: function(pos) {
            //console.log("position", pos)
            this.widget_settings.position = pos
            this.update_position(pos)
        },
        update_position: function(pos)
        {
            let url = this.$page.props.api_url+'/v1/settings/appearance';
            //console.log("updateSettings", $('#hexval').val())
            //initial[0] = $('#hexval').val();
            //$('#hexvalLabel').val(initial[0]);
            var params = {
                w_pos: pos
            };
            axios.post(url, params)
            .then(response => {
                //console.log(response.data);
                if (response.data) {
                    this.widget_settings = JSON.parse(response.data.settings)
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Launcher updated!", options)
                    this.set_onboarding_done()
                }
            })
            .catch(e => {
                console.error(e);
            });
        },
        set_onboarding_done() {
            if (this.onboard_launcher) {
                //this.EventBus.emit('onboarding_step_validation','onboard_customize');
                return
            }
            let url = this.$page.props.api_url+'/v1/team/set_meta';
            var params = {
                meta: "onboard_launcher",
                value: "yes"
            };
            axios.post(url, params)
            .then(response => {
                //console.log(response.data);
                if (response.data) {
                    this.onboard_launcher = true
                    this.EventBus.emit('onboarding_step_validation','onboard_launcher');
                }
            })
            .catch(e => {
                console.error(e);
            });
        }*/
    }

}

</script>

<style scoped>
.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    transition: all 0.2s ease-out;
}

.fade-leave-to {
    opacity: 0;
}

.fade-leave-active {
    transition: all 0.2s ease-in;
}



.widget {
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 20%;
    /* opacity: 0.5; */
}

.widget.active {
    opacity: 1;
}

.widget-left {
    background-image: url(/img/widgetl.svg);
}

.widget-left.active,
.widget-left:hover {
    background-image: url(/img/widgetl_w.svg);
}

.widget-right {
    background-image: url(/img/widgetr.svg);
}

.widget-right.active,
.widget-right:hover {
    background-image: url(/img/widgetr_w.svg);
}

.widget-blank {
    background-image: url(/img/widgetb.svg);
}

.widget-blank.active,
.widget-blank:hover {
    background-image: url(/img/widgetb_w.svg);
}

.zest {
    background-image: url(/img/logo-white-birdie.svg);
    background-position: center center;
    background-size: 40%;
    background-repeat: no-repeat;
    -moz-transition: right 0.4s ease-in-out, left 0.4s ease-in-out, opacity 0.2s ease-in-out;
    -webkit-transition: right 0.4s ease-in-out, left 0.4s ease-in-out, opacity 0.2s ease-in-out;
    transition: right 0.4s ease-in-out, left 0.4s ease-in-out, opacity 0.2s ease-in-out;
}

.zest.br {
    left: 81%;
}

.zest.bl {
    left: 4%;
}

.code_background {
    background-color: #172938;
}

/* .hljs {
    background: transparent!important;
} */
</style>
